import { render, staticRenderFns } from "./USU003_admSolicitante.vue?vue&type=template&id=4dcfbfef&"
import script from "./USU003_admSolicitante.vue?vue&type=script&lang=js&"
export * from "./USU003_admSolicitante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports